import { category as categoryIcon } from "assets/icons";
import styled from "@emotion/styled";
import { Cascader, Col, Form, Select, Spin } from "antd";
import { useGetAllCategory, useGetCategory } from "hooks/useCategory";
import { FC, useEffect, useState } from "react";
import { CategoryResponse } from "services/interface";

const { Option } = Select;

interface Option {
  value: string | number;
  label: string | number;
}

interface ProductCategoryCardProps {
  is_active?: boolean;
}

const ProductCategoryCard: FC<ProductCategoryCardProps> = ({ is_active }) => {
  const [category, setCategory] = useState<CategoryResponse>([]);
  // const [options, setOptions] = useState<Option[]>([]);

  // const { data, isLoading } = useGetCategory();
  const { data, isLoading } = useGetAllCategory();

  useEffect(() => {
    if (data) {
      setCategory(data);
    }
  }, [data]);

  // console.log("category", category);

  const children: React.ReactNode[] = [];

  category.forEach((item) => {
    //children.push(<Option key={item.id}>{item.name}</Option>);
    if (item.childrens) {
      children.push(<Option key={item.id} value={item.id}>{item.name}</Option>);
      item.childrens.forEach((child) => {
        children.push(<Option key={child.id} value={child.id}>{child.name}</Option>);
        if (child.childrens) {
          child.childrens.forEach((child) => {
            children.push(<Option key={child.id} value={child.id}>{child.name}</Option>);
          })
        }
      })
    } else {
      children.push(<Option key={item.id} value={item.id}>{item.name}</Option>);
    }
  });

  // useEffect(() => {
  //   if (data) {
  //     const options: Option[] = data.map((item) => {
  //       if (item?.childrens?.length > 0) {
  //         return {
  //           value: item.id,
  //           label: item.name,
  //           children: item.childrens.map((child) => {
  //             if (child?.childrens?.length > 0) {
  //               return {
  //                 value: child.id,
  //                 label: child.name,
  //                 children: child.childrens.map((child) => {
  //                   return {
  //                     value: child.id,
  //                     label: child.name,
  //                   };
  //                 }),
  //               };
  //             }
  //             return {
  //               value: child.id,
  //               label: child.name,
  //             };
  //           }),
  //         };
  //       }
  //       return {
  //         value: item.id,
  //         label: item.name,
  //         children: [],
  //       };
  //     });

  //     setOptions(options);
  //   }
  // }, [data]);

  return (
    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} >
      <WrapperAll>
        <SpanIcon>{categoryIcon}</SpanIcon>
        <FormWrapper>
          <Form.Item
            label="หมวดหมู่สินค้า"
            name="category_id"
            rules={[{
              required: true,
              message: "กรุณาเลือกหมวดหมู่สินค้า"
            }]}
          >
            <Select
              showSearch
              placeholder="ประเภทสินค้าที่ขาย"
              optionFilterProp="children"
              notFoundContent={isLoading ? <Spin size="small" /> : null}
              loading={isLoading}
            >
              {children}
            </Select>
            {/* <Cascader
              placeholder="กรุณาเลือกหมวดหมู่สินค้า"
              loading={isLoading}
              options={options}
              onChange={(value) => console.log(value)}
            /> */}
          </Form.Item>
        </FormWrapper>
      </WrapperAll>
    </Col>
  );
};

export default ProductCategoryCard;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 0px 20px;
  border-radius: 8px;
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 76px;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 8px;
`;